import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-play-circle-line"></i>
            精彩推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            剧情解说与名场面
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            热门韩漫精彩片段与深度剧情解析
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  width="400"
                  height="225"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                {idx < 2 && (
                  <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-medium">
                    热门
                  </span>
                )}
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}